import { render, staticRenderFns } from "./OSSUpload.vue?vue&type=template&id=729e9a72&scoped=true&"
import script from "./OSSUpload.vue?vue&type=script&lang=js&"
export * from "./OSSUpload.vue?vue&type=script&lang=js&"
import style0 from "./OSSUpload.vue?vue&type=style&index=0&id=729e9a72&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729e9a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('729e9a72', component.options)
    } else {
      api.reload('729e9a72', component.options)
    }
    module.hot.accept("./OSSUpload.vue?vue&type=template&id=729e9a72&scoped=true&", function () {
      api.rerender('729e9a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/OSSUpload.vue"
export default component.exports